import React from 'react';

const TermsConditions = () => {
  return (
    <div className="font-jost w-full max-w-4xl mx-auto px-6 py-16 md:py-24 text-gray-800 bg-white min-h-screen">
      <h1 className="text-3xl md:text-5xl font-bold mb-8 text-black">Terms & Conditions</h1>
      
      <div className="space-y-6 leading-relaxed">
        <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>
        
        <h2 className="text-xl font-semibold mt-8 text-black">1. Agreement to Terms</h2>
        <p>By viewing or using this website, you agree to be bound by these Terms and Conditions and our Privacy Policy. If you do not agree to these terms, please do not use our services.</p>

        <h2 className="text-xl font-semibold mt-8 text-black">2. Products and Services</h2>
        <p>All products are subject to availability, and we cannot guarantee that items will be in stock. We reserve the right to discontinue any products at any time for any reason.</p>
        
        <h2 className="text-xl font-semibold mt-8 text-black">3. Purchases and Payment</h2>
        <p>We accept various forms of payment including credit cards and Stripe. You agree to provide current, complete, and accurate purchase and account information for all purchases made via the Site.</p>
        
        <h2 className="text-xl font-semibold mt-8 text-black">4. Returns and Refunds</h2>
        <p>Please review our Return Policy posted on the Site prior to making any purchases. Exceptions may apply based on product conditions and health standards.</p>

        <h2 className="text-xl font-semibold mt-8 text-black">5. Contact Us</h2>
        <p>In order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:</p>
        <p><strong>info@wittynailtip.com</strong></p>
      </div>
    </div>
  );
};

export default TermsConditions;
